import React, { useEffect } from "react";
import { useState } from "react";
import { MdDarkMode, MdLightMode } from "react-icons/md";

function Theme() {
  const [theme, setTheme] = useState(
    localStorage.getItem("theme") ? localStorage.getItem("theme") : "system"
  );
  const element = document.documentElement;

  useEffect(() => {
    switch (theme) {
      case "dark":
        element.classList.add("dark");
        localStorage.setItem("theme", "dark");
        break;
      case "light":
        element.classList.remove("dark");
        localStorage.setItem("theme", "light");
        break;
      default:
        localStorage.removeItem("theme");
        break;
    }
  }, [theme]);

  return (
    <>
      <div
        className="duration-100 dark:bg-darkSecondary dark:text-lightPrimary bg-lightSecondary rounded-xl p-3 cursor-pointer"
        onClick={() => {
          setTheme(theme === "dark" ? "light" : "dark");
        }}
      >
        <div className="">
          {theme === "light" ? (
            <MdDarkMode className="text-2xl" />
          ) : (
            <MdLightMode className="text-2xl" />
          )}
        </div>
      </div>
    </>
  );
}

export default Theme;
